const keyEvent = {
    inserted(el, binding) {
        if(process.client){
              document.addEventListener("keydown", (e) => {
            if (e.keyCode === 13) {
                binding.value()
            }
        })
        }
      
    }
}

export default keyEvent


// WEBPACK FOOTER //
// ./src/common/directives/keyEvent.js